/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const EditIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, d: "M20.633 6.116l-2.75-2.749a1.25 1.25 0 00-1.766 0L4.372 15.111s-0.003 0.003-0.003 0.005c-0.007 0.008-0.01 0.015-0.017 0.02a0.684 0.684 0 00-0.09 0.12c-0.01 0.015-0.018 0.033-0.025 0.048a0.713 0.713 0 00-0.05 0.127c-0.002 0.01-0.01 0.02-0.012 0.03L3.022 20.07a0.746 0.746 0 000.198 0.712 0.747 0.747 0 000.712 0.198l4.608-1.153a0.153 0.153 0 000.03-0.012 0.793 0.793 0 000.128-0.05c0.015-0.008 0.032-0.015 0.047-0.025a0.683 0.683 0 000.12-0.09 0.067 0.067 0 000.02-0.017S8.888 19.63 8.89 19.63L20.635 7.883A1.244 1.244 0 0021 6.998a1.234 1.234 0 00-0.367-0.882zM8.358 18.038L5.96 15.64l8.734-8.735 2.397 2.397-8.734 8.735z" })));
};
//# sourceMappingURL=EditIcon.js.map